// extracted by mini-css-extract-plugin
export default {"mobileBreak":"NextVisit_mobileBreak__LSwYL","nextVisit":"NextVisit_nextVisit__wX-JE","linkWrapper":"NextVisit_linkWrapper__8rxwm","btnText":"NextVisit_btnText__oM24k"};